export const ENV_API_URL_OSM = "osm.omnixsystem.com/v3/security/"
export const ENV_API_URL_MIDDLEWARE = "middleware.omnixsystem.com/"
export const ENV_API_URL_OOM = "oom.omnixsystem.com/v3/"
export const ENV_API_URL_OSRM = "osrm.omnixsystem.com/v3/"

// endpoints
export const API_URL_USER = "user"
export const API_URL_QUERY = "query"
export const API_URL_SEARCH = "search"
export const API_URL_ORDER = "order"
export const API_URL_SG = "shippinggroup"

export const GOOGLE_MAPS_API_KEY="AIzaSyBzRcDwV2mi6Kjb1T4DRkqcXwPJj9Yz5VQ"
